import type { AnchorHTMLAttributes, FC, ReactNode } from 'react';

import type { ClassNameProps } from '@tripleten/cn';

import { cnLink } from './link.constants.js';

import './link.css';

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement>, ClassNameProps {
    children?: ReactNode;
}

export const Link: FC<LinkProps> = ({ className, children, ...props }) => {
    return (
        <a className={cnLink({}, [className])} {...props}>
            {children}
        </a>
    );
};
